import { Grid } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import styles from '@features/categories/components/CategoriesProgressLine/CategoriesProgressLine.styles';
import ProgressBar from '@components/Progress/ProgressBar';
type PropsType = {
  actualCount?: number;
  maxCount: number;
};
const CategoriesProgressLine = ({
  actualCount = 0,
  maxCount
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <>
      <Grid columns={1} sx={styles.visableCount}>
        {actualCount} {t('of')} {maxCount} {t('products.genitive')}
      </Grid>
      <ProgressBar actualCount={actualCount} maxCount={maxCount} />
    </>;
};
export default CategoriesProgressLine;